import { Injectable ,EventEmitter} from '@angular/core';
import { ConstantsService } from './constants.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  primarySite:EventEmitter<any> = new EventEmitter<any>();
  userDetails:EventEmitter<any> = new EventEmitter<any>();
  updateUserRole:EventEmitter<any> = new EventEmitter<any>();
  updateMenuHighlight:EventEmitter<any> = new EventEmitter<any>();
  updateSiteValue:EventEmitter<any> = new EventEmitter<any>();
  constructor(private http: HttpClient, private constantsService: ConstantsService) { }

  getUserDetails(GUID: any): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/getUserDetails/${GUID}`, {headers : this.constantsService.httpOptions, responseType:'json'})
      .pipe(
        catchError(this.handleError));
  }

  getSiteList(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/siteList`, {headers : this.constantsService.httpOptions, responseType:'json'})
      .pipe(
        catchError(this.handleError));
  }

  changePrimarySite(reqObj: any): Observable<any> {
    return this.http
      .post(`${this.constantsService.baseAPIURL}/changeSite`, reqObj, {headers : this.constantsService.httpOptions, responseType:'json'})
      .pipe(
        catchError(this.handleError));
  }


  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
}
